module.exports = __webpack_public_path__ + "img/click.eeb5d7c4.png";